import { render, staticRenderFns } from "./View13.vue?vue&type=template&id=71a06086&scoped=true&"
import script from "./View13.vue?vue&type=script&lang=js&"
export * from "./View13.vue?vue&type=script&lang=js&"
import style0 from "./View13.vue?vue&type=style&index=0&id=71a06086&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a06086",
  null
  
)

export default component.exports